/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let invalid_fields = {};
const error_fields = {
  first_name: 'First name',
  last_name: 'Last name',
  number: 'Credit Card number',
  month: 'Expiration Month',
  year: 'Expiration Year',
  cvv: 'CVV'
};

this.paymentFormSubmit = function() {
  $('#payment-form').submit(function(event) {
    const form = $(this);
    event.preventDefault();
    form.find('input[type=submit]').prop('disabled', true);
    recurlyResponseHandler(form);
    return false;
  });
};

const clear_errors = function() {
  invalid_fields = {};
};

const error = function(err, form) {
  $.each(err.fields, function(i, field) {
    if (typeof invalid_fields[field] === 'undefined') {
      invalid_fields[field] = field;
    }
  });
  const errors_markup = $.map(invalid_fields, field => ('<li>' + error_fields[field]) || (field + '</li>')).join('');
  form.find('.payment-errors').show();
  form.find('.payment-errors ul').empty().append(errors_markup);
  form.find('input[type=submit]').removeClass('disabled').removeAttr('disabled');
  form.find('button[type=submit]').removeClass('processing');
};

var recurlyResponseHandler = function(form) {
  clear_errors();
  recurly.token(form, function(err, token) {
    if (err) {
      error(err, form);
    } else {
      // recurly.js has filled in the 'token' field, so now we can submit the
      // form to your server; alternatively, you can access token.id and do
      // any processing you wish
      if ($('#payment-form').get(0).getAttribute('data-remote') === 'true') {
        $.ajax({
          url: $('#payment-form').get(0).getAttribute('action'),
          type: 'POST',
          data: $('#payment-form').serialize(),
          success(str) {
            return showColleagues();
          }
        });
      } else {
        // and re-submit
        form.get(0).submit();
      }
    }
  });
};

$('#credit-card-form').bind('ajax:success', (xhr, data, status) => showColleagues());

$(document).on('click', '#confirm-bidder-participation', () => showColleagues());

var showColleagues = function() {
  if ($('#colleagues_to_appoint').length > 0) {
    $('#bidder_joining').hide();
    return $('#colleagues_to_appoint').show();
  }
};
